import type { SVGProps } from 'react';
const SvgHdrOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#hdr_on_svg__a)">
      <path
        fill="currentColor"
        d="M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4Zm-1.5 0h-2v-1h2v1Zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2ZM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5Zm0 4.5h-2v-3h2v3Z"
      />
    </g>
    <defs>
      <clipPath id="hdr_on_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHdrOn;
